import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import compareProps from '../../../../utils/compareProps';
import HandOffLink from '../../../../utils/urls/HandOffLink';

const promotionWidth = 150;
const promotionMargin = 20;

const Promo = styled.div`
  margin-left: ${promotionMargin}px;
  display: none;

  :first-child {
    margin-left: 0;
  }

  @media (min-width: ${({ baseWidth, index }) =>
      baseWidth + promotionWidth * (index + 1) + promotionMargin * index}px) {
    :nth-child(${({ index }) => index + 1}) {
      display: block;
    }
  }
`;

const PromoLink = styled(HandOffLink)`
  cursor: pointer;
`;

const Promotion = ({
  baseWidth,
  index,
  title,
  source,
  link,
  path,
  promoHeight,
  onClick,
}) => {
  if (!source) return null;

  let content = <img src={source} alt={title} height={promoHeight} />;

  if (link && link.length) {
    content = (
      <PromoLink
        href={link}
        preRedirects={[() => onClick({ href: link, path })]}
      >
        {content}
      </PromoLink>
    );
  }

  return (
    <Promo baseWidth={parseInt(baseWidth, 10)} index={parseInt(index, 10)}>
      {content}
    </Promo>
  );
};

Promotion.propTypes = {
  title: PropTypes.string,
  source: PropTypes.string,
  link: PropTypes.string,
  path: PropTypes.arrayOf(PropTypes.string),
  onClick: PropTypes.func,
  promoHeight: PropTypes.string.isRequired,
};

export default memo(Promotion, (prevProps, nextProps) =>
  compareProps(prevProps, nextProps, ['source', 'path', 'link', 'promoHeight']),
);
